import { render, staticRenderFns } from "./Potential.vue?vue&type=template&id=98c17e08&scoped=true&"
import script from "./Potential.vue?vue&type=script&lang=js&"
export * from "./Potential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c17e08",
  null
  
)

export default component.exports